import { render } from "./SelectSkills.vue?vue&type=template&id=3fb97584&scoped=true"
import script from "./SelectSkills.vue?vue&type=script&lang=js"
export * from "./SelectSkills.vue?vue&type=script&lang=js"

import "./SelectSkills.vue?vue&type=style&index=0&id=3fb97584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb97584"]])

export default __exports__